import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import FormSelect from "Common/Custom/FormSelect";
import FormInput from "Common/Custom/FormInput";
import FormPhoneInput from "Common/Custom/FormPhoneInput";
import { validateField, validateForm } from "utils/validation";
import { PoolPackageCustomerRules } from "validation/ValidationRules";
import PropTypes from "prop-types";

const AddCustomerModal = ({
    show = false,
    onHide = () => { },
    OldCustomerOptions = [],
    newcustomer = [],
    onSave = () => { },
}) => {
    const [localValues, setLocalValues] = useState({
        customer_type: "new_customer",
        customer_id: ""
    });

    const [errors, setErrors] = useState({});

    const handleLocalChange = (e) => {
        const { name, value } = e.target;
        setLocalValues(prev => ({ ...prev, [name]: value }));
        if (PoolPackageCustomerRules) {
            const errorMsg = validateField(name, value, PoolPackageCustomerRules);
            setErrors((prev) => ({
                ...prev,
                [name]: errorMsg,
            }));
        }
    };

    const handleSave = () => {
        if (localValues.customer_type === "old_customer") {
            // For old customer, only validate that a customer is selected
            if (!localValues.customer_id) {
                setErrors({ customer_id: "Please select a customer" });
                return;
            }
            const customer = OldCustomerOptions.find(
                c => c.customer_id === Number(localValues.customer_id)
            );
            if (!customer) {
                setErrors({ customer_id: "Customer not found" });
                return;
            }
            onSave({ ...customer, customer_type: "old_customer" });
        } else {
            // For new customer, validate all required fields
            const err = validateForm(localValues, PoolPackageCustomerRules);
            if (err && Object.keys(err).length) {
                setErrors(err);
                return;
            }
            onSave({
                customer_id: Date.now(),
                customer_name: `${localValues.first_name} ${localValues.last_name}`,
                ...localValues,
                customer_type: "new_customer"
            });
        }
        onHide();
    };
    const rootContainer = document.getElementById("root-container");
    return (
        <Modal
            show={show}
            onHide={onHide}
            centered size="lg"
            container={rootContainer}
        >
            <Modal.Header closeButton>
                <Modal.Title>Create Customer</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className="row g-3">
                    <FormSelect
                        field={{
                            name: "customer_type",
                            label: "Customer Type",
                            fieldSize: "col-md-6",
                            required: true
                        }}
                        value={localValues.customer_type}
                        handleChange={handleLocalChange}
                        options={[
                            { value: "old_customer", label: "Old Customer" },
                            { value: "new_customer", label: "New Customer" }
                        ]}
                        error={errors.customer_type}
                    />

                    {localValues.customer_type === "old_customer" && (
                        <FormSelect
                            field={{
                                name: "customer_id",
                                label: "Select Customer",
                                fieldSize: "col-md-6",
                                required: true
                            }}
                            value={localValues.customer_id}
                            handleChange={handleLocalChange}
                            options={OldCustomerOptions.map(c => ({
                                value: c.customer_id,
                                label: c.customer_name
                            }))}
                            error={errors.customer_id}
                        />
                    )}

                    {localValues.customer_type === "new_customer" &&
                        newcustomer.map(field => {
                            if (field.type === "select") {
                                return (
                                    <FormSelect
                                        key={field.name}
                                        field={field}
                                        value={localValues[field.name]}
                                        handleChange={handleLocalChange}
                                        options={field.options || []}
                                        error={errors[field.name]}
                                    />
                                );
                            }
                            if (field.type === "tell") {
                                return (
                                    <FormPhoneInput
                                        key={field.name}
                                        field={field}
                                        value={localValues[field.name]}
                                        country_code={localValues['country_dial_code']}
                                        handleChange={handleLocalChange}
                                        error={errors[field.name]}
                                    />
                                );
                            }

                            return (
                                <FormInput
                                    key={field.name}
                                    field={field}
                                    value={localValues[field.name] || ""}
                                    handleChange={handleLocalChange}
                                    error={errors[field.name]}
                                />
                            );
                        })}
                </div>
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Close
                </Button>
                <Button variant="primary" onClick={handleSave}>
                    Save
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default AddCustomerModal;
